import React from "react"
import { AppBar, Toolbar, Box, IconButton } from "@mui/material"
import { makeStyles } from "makeStyles"

import clsx from "clsx"
import Icon from "@mdi/react"
import { mdiMenu, mdiPencil, mdiArrowRightThick, mdiTagOutline } from "@mdi/js"

import Price from "components/Price"
import Button from "components/Buttons/Button"

import { LockingSystemConfiguratorView } from "../LockingSystemConfigurator"

import { blurredStyle } from "containers/CheckoutPage/OrderOverviewAndCheckout"

const drawerWidth = 240

const useStyles = makeStyles()((theme) => ({
	root: {
		display: "flex",
	},
	appBar: {
		background: "#263739",
		transition: theme.transitions.create(["margin", "width"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		width: `calc(100% - ${drawerWidth}px)`,
		marginLeft: drawerWidth,
		transition: theme.transitions.create(["margin", "width"], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
	},
	drawerHeader: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		// ...theme.mixins.toolbar,
		justifyContent: "flex-end",
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		marginLeft: -drawerWidth,
	},
	contentShift: {
		transition: theme.transitions.create("margin", {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginLeft: 0,
	},
}))

const LockingSystemHeader = ({
	title,
	toggleChangeNameModalIsOpen,
	sidebarIsOpen,
	toggleSidebarIsOpen,
	totalGrossPriceCents,
	view,
	setView,
	isFrozen,
	isLoading,
	addToCart,
}: Props) => {
	const { classes } = useStyles()

	return (
		<div className={classes.root}>
			<AppBar
				position="fixed"
				className={clsx(classes.appBar, {
					[classes.appBarShift]: sidebarIsOpen,
				})}
			>
				<Toolbar>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							width: "100%",
							paddingLeft: 25,
						}}
					>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								width: "100%",
							}}
						>
							<div style={{ display: "flex", alignItems: "center" }}>
								<IconButton
									color="inherit"
									aria-label="open-sidebar"
									onClick={toggleSidebarIsOpen}
									edge="start"
									className={classes.menuButton}
									size="large"
								>
									<Icon path={mdiMenu} size={1} />
								</IconButton>

								<Box
									ml={1}
									style={{
										fontSize: 18,
										display: "flex",
										alignItems: "center",
									}}
								>
									<strong>{title}</strong>
									<button
										color="inherit"
										aria-label="open-change-name-modal"
										onClick={toggleChangeNameModalIsOpen}
										disabled={isFrozen}
										id="locking-system-name"
										style={{
											background: "rgba(70, 145, 206, 1)",
											width: 30,
											height: 30,
											borderRadius: 3,
											textAlign: "center",
											border: "none",
											outline: "none",
											cursor: "pointer",
											marginLeft: 5,
										}}
									>
										<Icon path={mdiPencil} size={0.8} color="white" />
									</button>
								</Box>
							</div>
							<div style={{ display: "flex", float: "right" }}>
								<div
									style={{
										background: "#4691CE",
										padding: 4,
										height: 37,
										width: 37,
										marginTop: 6,
										borderRadius: 3,
									}}
								>
									<Icon path={mdiTagOutline} size={1.3} color="white" />
								</div>
								<Box ml={1} style={{ fontSize: 18, marginTop: 4 }}>
									<div style={{ fontSize: 12, marginBottom: -5 }}>
										Gesamtpreis
									</div>
									<strong style={isLoading ? blurredStyle : {}}>
										<Price priceInEuroCents={totalGrossPriceCents} />
									</strong>
								</Box>

								{view === "matrix" && (
									<Box
										ml={1}
										style={{
											fontSize: 18,
											marginTop: 5,
										}}
									>
										<Button
											style={{ backgroundColor: "#5DA67A", color: "#fff" }}
											onClick={() => setView("overview")}
											size="small"
										>
											Weiter
											<Icon path={mdiArrowRightThick} size={1} />
										</Button>
									</Box>
								)}

								{view === "overview" && (
									<>
										<Box ml={1} style={{ fontSize: 18, marginTop: 7 }}>
											<Button
												onClick={() => setView("matrix")}
												style={{ background: "#505E5F", color: "white" }}
												size="small"
											>
												Zurück
											</Button>
										</Box>
										<Box
											ml={1}
											style={{
												fontSize: 18,
												marginTop: 7,
											}}
										>
											<Button
												onClick={() => addToCart()}
												style={{
													backgroundColor: "#5DA67A",
													color: "#fff",
												}}
												disabled={isLoading}
												size="small"
											>
												In den Warenkorb
											</Button>
										</Box>
									</>
								)}
							</div>
						</div>
					</div>
				</Toolbar>
			</AppBar>
		</div>
	)
}

interface Props {
	title: string
	sidebarIsOpen: boolean
	toggleSidebarIsOpen: () => void
	toggleChangeNameModalIsOpen: () => void
	totalGrossPriceCents: number
	view: LockingSystemConfiguratorView
	setView: (view: LockingSystemConfiguratorView) => void
	isFrozen: boolean
	isLoading: boolean
	addToCart: () => void
}

export default LockingSystemHeader
